import { render } from "./ConversationItem.vue?vue&type=template&id=259fad33&scoped=true&lang=pug"
import script from "./ConversationItem.vue?vue&type=script&lang=js"
export * from "./ConversationItem.vue?vue&type=script&lang=js"

import "./ConversationItem.vue?vue&type=style&index=0&id=259fad33&lang=scss&scoped=true"
import "./ConversationItem.vue?vue&type=style&index=1&id=259fad33&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259fad33"]])

export default __exports__